import { render, staticRenderFns } from "./cashier.vue?vue&type=template&id=3e5642c9&"
import script from "./cashier.vue?vue&type=script&lang=js&"
export * from "./cashier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e5642c9')) {
      api.createRecord('3e5642c9', component.options)
    } else {
      api.reload('3e5642c9', component.options)
    }
    module.hot.accept("./cashier.vue?vue&type=template&id=3e5642c9&", function () {
      api.rerender('3e5642c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/after-sale/upgrade/components/cashier.vue"
export default component.exports